import { render, staticRenderFns } from "./ShipEdit.vue?vue&type=template&id=f15ddc2a&scoped=true&"
import script from "./ShipEdit.vue?vue&type=script&lang=js&"
export * from "./ShipEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15ddc2a",
  null
  
)

export default component.exports